module.exports = __webpack_public_path__ + "static/img/region_distribution_thumbnail.ce449e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/region_distribution_thumbnail.jpg
// module id = BE7I
// module chunks = 6